import * as React from 'react'

import { Box, Button, Space, TextBody } from '@ally/metronome-ui'
import { ForgotUsernameConfirmationProps } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { useAppState } from '../../AppStateProvider'

const ForgotUsernameConfirmationContent: React.FC<ForgotUsernameConfirmationProps> = ({
  username,
}) => {
  const {
    hostServices,
    navigateToForgotPassword,
    navigateToLogin,
  } = useTransmit()
  const { isWebWrapped } = useAppState()

  const onForgotPasswordClick = (): void => {
    if (isWebWrapped) {
      window.location.href = `ally://forgot-password?username=${username}`
    } else {
      navigateToForgotPassword({ username })
    }
  }
  const onLoginClick = (): void => {
    if (isWebWrapped) {
      window.location.href = `ally://login?username=${username}`
    } else {
      navigateToLogin({ username })
    }
  }

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'pageview',
      pageName: isWebWrapped
        ? 'ally mobile app:Web View:Forgot Username:Found You'
        : 'AOS:Login:Forgot Username:Found You',
    })
  }, [])

  return (
    <>
      <LoginHeading title="Found you" />
      <Space mb="md">
        <TextBody tag="p" size="md">
          Your username is:{' '}
          <TextBody tag="span" weight="bold" size="md">
            {username}
          </TextBody>
        </TextBody>
      </Space>
      <TextBody tag="p" size="md">
        If you want to change your username, log in and go to your{' '}
        <TextBody tag="span" weight="bold" size="md">
          Profile and Settings
        </TextBody>
        .
      </TextBody>
      <Button
        allytmln={
          isWebWrapped
            ? 'allyMobileAppWebViewForgotUsernameFoundYouForgotYourPassword'
            : 'forgotUsername-foundYou-forgotYourPasswordToo'
        }
        text="Forgot your password too?"
        onClick={onForgotPasswordClick}
        variant="link"
        mt="xs"
      />
      <Box>
        <Button
          allytmln={
            isWebWrapped
              ? 'allyMobileAppWebViewForgotUsernameFoundYouLogIn'
              : 'forgotUsername-foundYou-login'
          }
          text="Log In"
          mt="lg"
          onClick={onLoginClick}
        />
      </Box>
    </>
  )
}

export const ForgotUsernameConfirmation: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'ForgotUsernameConfirmation') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ForgotUsernameConfirmationContent {...activeScreen.payload} />
}
